import * as bootstrap from 'bootstrap';
import * as bootbox from '@w8tcha/bootbox';
export function errorLog(x) {
    console.error('An Error has occurred!', x);
}
export function empty(wrap) {
    while (wrap.firstChild) {
        wrap.removeChild(wrap.firstChild);
    }
}
export function wrap(el, wrapper) {
    var _a;
    (_a = el.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}
// Attachments/Albums Popover Preview
export function renderAttachPreview(previewClass) {
    const attachElements = document.querySelectorAll(previewClass);
    attachElements.forEach((attach) => {
        return new bootstrap.Popover(attach, {
            html: true,
            trigger: 'hover',
            placement: 'bottom',
            content: () => `<img src="${attach.src}" class="img-fluid" />`
        });
    });
}
// Toggle password visibility
export function togglePassword() {
    const passwordToggle = document.getElementById('PasswordToggle');
    if (passwordToggle && document.body.contains(passwordToggle)) {
        const icon = passwordToggle.querySelector('i');
        const pass = document.querySelector("input[id*='Password']");
        passwordToggle.addEventListener('click', (event) => {
            event.preventDefault();
            if (pass.getAttribute('type') === 'text') {
                pass.setAttribute('type', 'password');
                icon.classList.add('fa-eye-slash');
                icon.classList.remove('fa-eye');
            }
            else if (pass.getAttribute('type') === 'password') {
                pass.setAttribute('type', 'text');
                icon.classList.remove('fa-eye-slash');
                icon.classList.add('fa-eye');
            }
        });
    }
}
// Confirm Dialog
document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.parentElement && target.parentElement.matches('[data-bs-toggle="confirm"]')) {
        event.preventDefault();
        const button = target.parentElement;
        const text = button.dataset.title || '', yes = button.dataset.yes || '', no = button.dataset.no || '', title = button.innerHTML;
        button.innerHTML = "<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Loading...";
        bootboxConfirm(button, title, text, yes, no, (confirmed) => {
            if (confirmed) {
                button.click();
            }
        });
    }
}, false);
export function bootboxConfirm(button, title, message, yes, no, callback) {
    const options = {
        message: message,
        centerVertical: true,
        title: title
    };
    options.buttons = {
        cancel: {
            label: `<i class="fa fa-times"></i> ${no}`,
            className: 'btn-danger',
            callback(result) {
                callback(false);
                button.innerHTML = title;
            }
        },
        main: {
            label: `<i class="fa fa-check"></i> ${yes}`,
            className: 'btn-success',
            callback(result) {
                callback(true);
            }
        }
    };
    bootbox.dialog(options);
}
;
export function bootboxShareTopic(title, message, cancel, okay, value) {
    const options = {
        message: message,
        centerVertical: true,
        title: title,
        value: value
    };
    options.buttons = {
        cancel: {
            label: cancel
        },
        confirm: {
            label: okay
        }
    };
    options.callback = () => {
        copyToClipBoard(value);
    };
    bootbox.prompt(options);
}
;
export function copyToClipBoard(input) {
    navigator.clipboard.writeText(input);
}
const _global = (window /* browser */ || global /* node */);
_global.errorLog = errorLog;
_global.bootboxShareTopic = bootboxShareTopic;
_global.togglePassword = togglePassword;
_global.copyToClipBoard = copyToClipBoard;
